import {PublicInformationFormProps} from "../types";
import {Form} from "antd";
import {VALIDATION_MESSAGES} from "../../../../../enums/validationMessages";
import TextArea from "antd/es/input/TextArea";
import {useEffect} from "react";

const PublicInformationForm = (props: PublicInformationFormProps) => {
  const {form, submitButtonHandler, selectedPublicInfoItem} = props.publicInfoController

  useEffect(() => {
    if (selectedPublicInfoItem) {
      form.setFieldsValue(selectedPublicInfoItem)
    } else {
      form.resetFields()
    }
  }, [selectedPublicInfoItem])

  return (<Form form={form} layout="vertical" className="contactItem_form"
                onFinish={submitButtonHandler}>
    <Form.Item name="title" label="Заголовок" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
      <TextArea/>
    </Form.Item>
    <Form.Item name="fileLink" label="Посилання на файл"
               rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
      <TextArea autoSize={{minRows: 3}}/>
    </Form.Item>
  </Form>)
}

export default PublicInformationForm